// Import the Firebase modules that you need in your app.
import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/database';
// import 'firebase/datastore';

// Initalize and export Firebase.
const config = {
  apiKey: "AIzaSyCtRdgzAjqR_g3dndoKhrnyA_J_3avaYc0",
  authDomain: "chalkview.firebaseapp.com",
  databaseURL: "https://chalkview.firebaseio.com",
  projectId: "chalkview",
  storageBucket: "chalkview.appspot.com",
  messagingSenderId: "466413565571"
};
export default firebase.initializeApp(config);


// WEBPACK FOOTER //
// ./src/firebase.js